import { HORECA } from '@/constants/testIds';
import { Download } from 'lucide-react';
import LutfiyeLogo from './LutfiyeSignature';

const PRICE_LIST_PDF = '/lutfiye-toptan-fiyat-listesi.pdf';
const CATALOG_PDF = '/lutfiye-katalog.pdf';

const links = [
  { id: HORECA.navLinkAdvantages, href: '#avantajlar', label: 'Avantajlar' },
  { id: HORECA.navLinkAbout, href: '#hikayemiz', label: 'Amasra' },
  { id: HORECA.navLinkProducts, href: '#urunler', label: 'Ürünler' },
  { id: HORECA.navLinkSanver, href: '#sanver', label: 'Şanver' },
  { id: HORECA.navLinkProcess, href: '#surec', label: 'Süreç' },
  { id: HORECA.navLinkFaq, href: '#sss', label: 'SSS' },
  { id: HORECA.navLinkContact, href: '#iletisim', label: 'İletişim' },
];

export default function Header() {
  return (
    <header
      data-testid={HORECA.nav}
      className="fixed top-0 inset-x-0 z-50 bg-[#FBF7EE]/85 backdrop-blur-md border-b border-[#1F1F1F]/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-[76px]">
        <a href="#top" data-testid={HORECA.navLogo} className="flex items-center gap-3">
          <LutfiyeLogo
            width="w-24 md:w-28"
            height="h-9 md:h-10"
            color="text-[#1F1F1F]"
          />
          <span className="eyebrow text-[#B08834] pl-3 border-l border-[#1F1F1F]/15 h-4 leading-4 flex items-center">
            Horeca
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={l.id}
              className="text-sm text-[#1F1F1F]/70 hover:text-[#B03A2E] transition-colors font-body"
            >
              {l.label}
            </a>
          ))}
          <a
            href={CATALOG_PDF}
            target="_blank"
            rel="noreferrer"
            data-testid={HORECA.navLinkCatalog}
            className="inline-flex items-center gap-1.5 text-sm text-[#B08834] hover:text-[#B03A2E] transition-colors font-body"
            title="Ürün kataloğunu yeni sekmede aç / indir"
          >
            <Download className="w-3.5 h-3.5" />
            Katalog
          </a>
          <a
            href={PRICE_LIST_PDF}
            target="_blank"
            rel="noreferrer"
            data-testid={HORECA.navLinkPriceList}
            className="inline-flex items-center gap-1.5 text-sm text-[#B08834] hover:text-[#B03A2E] transition-colors font-body"
            title="Toptan fiyat listesini yeni sekmede aç / indir"
          >
            <Download className="w-3.5 h-3.5" />
            Fiyat Listesi
          </a>
        </nav>

        <a
          href="#iletisim"
          data-testid={HORECA.navCtaBtn}
          className="inline-flex items-center gap-2 bg-[#1F1F1F] hover:bg-[#B03A2E] text-[#FBF7EE] px-5 py-2.5 text-xs tracking-[0.2em] transition-colors font-body"
        >
          TEKLİF AL
        </a>
      </div>
    </header>
  );
}
